import React from 'react';

const ProgressBar = ({ progress }) => {
    return (
        <div className="w-full max-w-md mx-auto mb-8">
            <div className="w-full bg-gray-200 rounded-full h-2">
                <div
                    className="bg-orange-500 h-2 rounded-full transition-all duration-500 ease-out"
                    style={{ width: `${progress}%` }}
                ></div>
            </div>
            <p className="text-center text-sm text-gray-600 mt-2">
                Setting up your account...
            </p>
        </div>
    );
};

export default ProgressBar; 